export const STOCK_MOVEMENT = 'StockMovement';
export const StockMovementTypeValues = [
    'entry',
    'exit',
    'reversal',
    'transfer',
    'adjustment',
];
/** pt-BR labels for {@link StockMovementType}. */
export const STOCK_MOVEMENT_TYPE_LABELS = {
    entry: 'Entrada',
    exit: 'Saída',
    reversal: 'Estorno',
    transfer: 'Transferência',
    adjustment: 'Ajuste',
};
//# sourceMappingURL=stock-movement.js.map